<div class="file">
  @if(!attachment.isCorrupted){ @if (attachment.type === AttachmentTypes.IMAGE) {
  {{ attachment.error }}
  <img
    class="attachment"
    [src]="attachment.thumbnailURL"
    (error)="onImageError()"
    (click)="imagesService.openPhoto(attachment.thumbnailURL, attachment.title, errorOnLoad)" />
  } @if (attachment.type === AttachmentTypes.VIDEO) {
  <video
    controls
    controlsList="nopictureinpicture"
    disablePictureInPicture
    class="attachment"
    [src]="attachment.thumbnailURL"></video>
  } @if (attachment.type === AttachmentTypes.DOCUMENT) {
  <a [href]="attachment.thumbnailURL" target="_blank">
    <mat-icon svgIcon="file_download"></mat-icon>
    {{ attachment.title }}
  </a>
  } @if (attachment.type === AttachmentTypes.AUDIO) {
  <audio controls class="full-width">
    <source [src]="attachment.thumbnailURL" />
  </audio>
  } } @else {
  <mat-icon svgIcon="error-file"></mat-icon>
  Corrupted upload. Unable to display attachment. }
</div>
